import ResumeItem from '@/common/components/ResumeItem'
import CreateForwardingDirectiveEntryFormStepHeader from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/CreateForwardingDirectiveEntryFormStepHeader'
import { establishmentChoiceEntryOptions } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/establishmentChoiceEntry/establishmentChoiceEntryOptions.constant'
import { MaintenanceForwardingsEstablishmentChoiceEntryStepOptions } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'
import { EstablishmentChoiceEntryAuctionEntrySchema } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/schemas/maintenanceForwardingDirectiveSteps.schema'
import { useFormContext, useWatch } from 'react-hook-form'

const EstablishmentChoiceEntryAuctionEntryCompleted = () => {
  const { control } = useFormContext<EstablishmentChoiceEntryAuctionEntrySchema>()

  const { establishment_choice_entry_attributes: watchEstablishmentChoiceEntryAttributes } = useWatch({
    control,
  })

  const auctionEntryOption =
    establishmentChoiceEntryOptions[MaintenanceForwardingsEstablishmentChoiceEntryStepOptions.AuctionEntry]!

  return (
    <div className="flex flex-col gap-4">
      <CreateForwardingDirectiveEntryFormStepHeader
        title={auctionEntryOption.title}
        description={auctionEntryOption.description()}
      />

      <div className="flex flex-col gap-2">
        <div className="flex gap-4">
          <ResumeItem
            label="Tipo de leilão"
            value={(watchEstablishmentChoiceEntryAttributes?.kind?.label as string) || '--'}
            className="text-sm"
          />

          <ResumeItem
            label="Mínimo de propostas para arremate"
            value={watchEstablishmentChoiceEntryAttributes?.minimum_of_proposals_to_finish || '--'}
            className="text-sm"
          />

          {watchEstablishmentChoiceEntryAttributes?.will_select_allowed_establishments === '0' && (
            <ResumeItem
              label="Raio de exibição do leilão"
              value={watchEstablishmentChoiceEntryAttributes?.allowance_radius_in_kilometers || '--'}
              className="text-sm"
            />
          )}
        </div>

        <div className="flex gap-4">
          {watchEstablishmentChoiceEntryAttributes?.starts_at_date && (
            <>
              <ResumeItem
                label="Data de início"
                value={watchEstablishmentChoiceEntryAttributes?.starts_at_date || '--'}
                className="text-sm"
              />

              <ResumeItem
                label="Horário de início"
                value={watchEstablishmentChoiceEntryAttributes?.starts_at_time || '--'}
                className="text-sm"
              />
            </>
          )}

          <ResumeItem
            label="Data de encerramento"
            value={watchEstablishmentChoiceEntryAttributes?.finishes_at_date || '--'}
            className="text-sm"
          />

          <ResumeItem
            label="Horário de encerramento"
            value={watchEstablishmentChoiceEntryAttributes?.finishes_at_time || '--'}
            className="text-sm"
          />
        </div>

        <div className="flex gap-4">
          <ResumeItem
            label="Estabelecimentos participantes"
            value={
              watchEstablishmentChoiceEntryAttributes?.will_select_allowed_establishments === '0'
                ? 'Todos estabelecimentos aptos'
                : `${watchEstablishmentChoiceEntryAttributes?.allowed_establishment_ids?.length} Estabelecimentos selecionados`
            }
            className="text-sm"
          />
        </div>
      </div>
    </div>
  )
}

export default EstablishmentChoiceEntryAuctionEntryCompleted
